// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1761 ? "d0deef33" : chunkId) + "." + {"907":"80ff089ca15b1cca","1761":"487e6b50246a11d2","1924":"a547b3fe1c26acb8","9543":"53303c858a5d05e8"}[chunkId] + ".js";
};